/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierProBlockDetail
 */
export interface CarrierProBlockDetail {
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockDetail
   */
  carrierProBlockId: string;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockDetail
   */
  startNumber: number;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockDetail
   */
  endNumber: number;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockDetail
   */
  nextNumber: number;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockDetail
   */
  remaining: number;
  /**
   *
   * @type {boolean}
   * @memberof CarrierProBlockDetail
   */
  active: boolean;
}

/**
 * Check if a given object implements the CarrierProBlockDetail interface.
 */
export function instanceOfCarrierProBlockDetail(
  value: object,
): value is CarrierProBlockDetail {
  if (
    !("carrierProBlockId" in value) ||
    value["carrierProBlockId"] === undefined
  )
    return false;
  if (!("startNumber" in value) || value["startNumber"] === undefined)
    return false;
  if (!("endNumber" in value) || value["endNumber"] === undefined) return false;
  if (!("nextNumber" in value) || value["nextNumber"] === undefined)
    return false;
  if (!("remaining" in value) || value["remaining"] === undefined) return false;
  if (!("active" in value) || value["active"] === undefined) return false;
  return true;
}

export function CarrierProBlockDetailFromJSON(
  json: any,
): CarrierProBlockDetail {
  return CarrierProBlockDetailFromJSONTyped(json, false);
}

export function CarrierProBlockDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierProBlockDetail {
  if (json == null) {
    return json;
  }
  return {
    carrierProBlockId: json["carrierProBlockId"],
    startNumber: json["startNumber"],
    endNumber: json["endNumber"],
    nextNumber: json["nextNumber"],
    remaining: json["remaining"],
    active: json["active"],
  };
}

export function CarrierProBlockDetailToJSON(json: any): CarrierProBlockDetail {
  return CarrierProBlockDetailToJSONTyped(json, false);
}

export function CarrierProBlockDetailToJSONTyped(
  value?: CarrierProBlockDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierProBlockId: value["carrierProBlockId"],
    startNumber: value["startNumber"],
    endNumber: value["endNumber"],
    nextNumber: value["nextNumber"],
    remaining: value["remaining"],
    active: value["active"],
  };
}
